import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, exhaustMap, tap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as DashboardActions from './dashboard.actions';
import { DashboardService } from '../services/dashboard.service';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { UpcomingRemindersService } from '../components/services/upcoming-reminders/upcoming-reminders.service';
import { ToastService } from 'app/toast/services/toast.service';


@Injectable()
export class DashboardEffects {


  loadOrgDonations$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(DashboardActions.loadOrgDonations),
      exhaustMap((action: any) => {
        return this.dashboardService.getOrgDonations(action.payload).pipe(
          map(data =>{
            return DashboardActions.loadOrgDonationsSuccess({ data })} ),
          catchError(error => of(DashboardActions.loadOrgDonationsFailure({ error }))))
      })
    );
  });

  loadCampaignReport$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(DashboardActions.loadCampaignReport),
      exhaustMap((action: any) => {
        return this.dashboardService.getCampaignReport(action.payload).pipe(
          map(data =>{
            return DashboardActions.loadCampaignReportSuccess({ data })} ),
          catchError(error => of(DashboardActions.loadCampaignReportFailure({ error }))))
      })
    );
  });

  loadOrgUser$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(DashboardActions.loadOrgUser),
      exhaustMap((action: any) => {
        const reload = _.get(action,'payload.reload',false)
        return this.authService.getOrgUser(reload).pipe(
          map(data =>{
            return DashboardActions.loadOrgUserSuccess({ data })} ),
          catchError(error => of(DashboardActions.loadOrgUserFailure({ error }))))
      })
    );
  });

  switchOrgUser$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(DashboardActions.switchOrgUser),
      exhaustMap((action: any) => {
        const destOrgId = _.get(action,'payload.destOrgId',"")
        return this.authService.switchOrgUser(destOrgId).pipe(
          map(data =>{
            window.location.reload();
            return DashboardActions.loadOrgUser({ payload: { reload: true } })} ),
          catchError(error => of(DashboardActions.switchOrgUserFailure({ error }))))
      })
    );
  });

  loadUpcomingReminders$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(DashboardActions.loadUpcomingReminders),
      exhaustMap((action: any) => {
        return this.upcomingRemindersService.getUpcomingSchedulers().pipe(
          map(data => DashboardActions.loadUpcomingRemindersSuccess({ data })),
          catchError(error => of(DashboardActions.loadUpcomingRemindersFailure({ error }))))
      })
    );
  });

  cancelUpcomingReminder$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(DashboardActions.cancelUpcomingReminder),
      exhaustMap((action: any) => {
        const taskId = action.payload
        return this.upcomingRemindersService.cancelReminder(taskId).pipe(
          tap(() => {
            this.toastService.show('success', 'Cancelled Successfully');
          }),
          map(() => DashboardActions.cancelUpcomingReminderSuccess({ data: taskId})),
          catchError(error => of(DashboardActions.cancelUpcomingReminderFailure({ error }))))
      })
    );
  });

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private upcomingRemindersService: UpcomingRemindersService,
    private toastService: ToastService,
  ) {}

}
